var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWebinarsinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F1F1F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 11.666h-12.5a3.754 3.754 0 00-3.75 3.75v9.167a3.754 3.754 0 003.75 3.75h12.5a3.754 3.754 0 003.75-3.75v-9.167a3.754 3.754 0 00-3.75-3.75zm-2.97 9.452l-4.804 2.401a1.25 1.25 0 01-1.81-1.118v-4.803a1.25 1.25 0 011.81-1.119l4.803 2.402a1.25 1.25 0 010 2.237z",
    fill: "#0F0449"
  })));
}

export default SvgWebinarsinline;